import { render, staticRenderFns } from "./ProfileSelectionView.vue?vue&type=template&id=c705c0fe"
import script from "./ProfileSelectionView.vue?vue&type=script&lang=ts"
export * from "./ProfileSelectionView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports